import get from 'lodash/get'
import PropTypes from 'prop-types'

import { ImageType } from '../types'
import { BlockSectionTitle, BlockWrapper, Container, HotLeisureTips } from 'common/widgets'


AccordionWithImages.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    leisure_tips: PropTypes.arrayOf(PropTypes.shape({
      heading: PropTypes.string,
      text: PropTypes.string,
      images: PropTypes.arrayOf(ImageType),
    })),
  }),
}

export default function AccordionWithImages({
  data = {
    leisure_tips: [],
  },
}) {
  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <HotLeisureTips data={get(data, 'leisure_tips', [])} />
      </Container>
    </BlockWrapper>
  )
}
